import { Content } from "@iventis/translations/content/typed-content";
import React from "react";
import { Body1, Header4 } from "@iventis/styles/src/components/texts";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { IventisFooter, SiteLogoComponent } from "@iventis/components";
import { LoginPanelContainer, LoginPageContainer } from "@iventis/components/src/login-containers";
import { ForgottenPasswordForm } from "./forgotten-password-form";
import { LoginBackground } from "./login";

export const ForgottenPasswordComponent = () => {
    const translate = useIventisTranslate();
    return (
        <LoginBackground>
            <LoginPageContainer>
                <LoginPanelContainer>
                    <SiteLogoComponent />
                    <Header4 data-testid="forgot-pass-header4">{translate(Content.login.headings.forgotten)}</Header4>
                    <Body1 data-testid="forgot-pass-body1" style={{ marginRight: "2%" }}>
                        {translate(Content.login.subHeadings.forgotten)}
                    </Body1>
                    <ForgottenPasswordForm />
                </LoginPanelContainer>
                <IventisFooter />
            </LoginPageContainer>
        </LoginBackground>
    );
};

export default ForgottenPasswordComponent;
